// extracted by mini-css-extract-plugin
export var icon = "_wm-0";